import React, {useState} from 'react';

import find from 'lodash/find';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import styled from 'styled-components';

import {DebouncedInput} from 'app/general/primitives/DebouncedInput';
import {StepSelect} from 'app/procedures/components/StepSelect';
import {gt} from 'app/utils/i18n';

import type {AttachedChoiceType, ProcedureStepType} from 'sweet-types';

const StyledRoundedDiv = styled.div`
  > *:first-child {
    > .form-control {
      border-bottom-left-radius: 0;
    }

    > .input-group-append > * {
      border-top-right-radius: 0.25rem !important;
    }
  }

  > *:last-child > div {
    border-top: none;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`;

type Props = {
  choice: AttachedChoiceType;
  steps: Array<ProcedureStepType>;
  index: number;
  numChoices: number;
  onRemove: (item: AttachedChoiceType) => void;
  onChange: (item: AttachedChoiceType) => void;
  onReorder: (index: number, newIndex: number) => void;
  onSetDestination: (arg0: string | void) => void;
  createAndSetDestination: (title: string) => void;
};

export const EditableChoiceField = ({
  choice,
  onChange,

  createAndSetDestination,
  index,
  onRemove,
  steps,
  numChoices,
  onSetDestination,
  onReorder,
}: Props) => {
  const [name, setName] = useState<string>(choice.name);
  const {dest} = choice;

  const changeName = (name: string) => {
    onChange({...choice, name});
    setName(name);
  };

  return (
    <StyledRoundedDiv className="my-2 text">
      <div className="input-group">
        <DebouncedInput
          delay={1000}
          className="form-control field-name"
          type="text"
          value={name}
          onChange={changeName}
          placeholder={gt('Answer description...')}
        />
        <UncontrolledDropdown className="input-group-append">
          <DropdownToggle color="light">
            <i className="fa fa-ellipsis-v px-1" />
          </DropdownToggle>
          <DropdownMenu right>
            {index > 0 ? (
              <DropdownItem onClick={() => onReorder(index, index - 1)}>
                <i className="fa fa-fw fa-arrow-up" /> {gt('Move up')}
              </DropdownItem>
            ) : null}
            {index < numChoices - 1 ? (
              <DropdownItem onClick={() => onReorder(index, index + 1)}>
                <i className="fa fa-fw fa-arrow-down" /> {gt('Move down')}
              </DropdownItem>
            ) : null}
            <DropdownItem onClick={() => onRemove(choice)}>
              <i className="fa fa-fw fa-times" /> {gt('Remove')}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
      <StepSelect
        value={find(steps, {
          id: dest,
        })}
        onChange={onSetDestination}
        steps={steps}
        onCreateStep={createAndSetDestination}
      />
    </StyledRoundedDiv>
  );
};
